/** Parse `excluded` from invite URL query values. */
export function parseClientConnectExcludedFlag(value) {
  if (value == null || value === '') {
    return false;
  }

  const normalized = String(value).trim().toLowerCase();
  return normalized === 'true' || normalized === '1' || normalized === 'yes';
}

/** Excluded via invite URL (`excluded=true`), stored on login. */
export function isClientConnectExcludedFromUrl() {
  return parseClientConnectExcludedFlag(localStorage.getItem('client_connect_excluded'));
}

/** Excluded via survey payload recipient list (existing API behaviour). */
export function isClientConnectRecipientExcluded(clientConnect, email = localStorage.getItem('email')) {
  if (!email) {
    return false;
  }

  const recipients = clientConnect?.recipients;
  if (!Array.isArray(recipients) || !recipients.length) {
    return false;
  }

  return Boolean(recipients.find((recipient) => recipient?.email === email)?.excluded);
}

/** True when URL flag or API recipient marks the user as excluded. */
export function isClientConnectExcludedUser(clientConnect, email = localStorage.getItem('email')) {
  return isClientConnectExcludedFromUrl() || isClientConnectRecipientExcluded(clientConnect, email);
}
